module.exports = __webpack_public_path__ + "static/img/journal.5dca9234.png";